// extracted by css-extract-rspack-plugin
export default {"container":"top-banner-container-module__container___lAerc"};